(function(){
  'use strict';
  document.addEventListener('click',function(event){
    var button=event.target&&event.target.closest&&event.target.closest('.cart__form input[type="submit"][name="checkout"]');
    if(!button)return;
    var label=(button.value||button.getAttribute('value')||'').trim();
    if(!label)return;
    var expires=Date.now()+2100;
    function restore(){
      if(!button.isConnected)return;
      if(!String(button.value||'').trim())button.value=label;
    }
    var observer=window.MutationObserver&&new MutationObserver(restore);
    if(observer)observer.observe(button,{attributes:true,attributeFilter:['value','class','style','disabled']});
    function watch(){
      restore();
      if(Date.now()<expires&&button.isConnected)requestAnimationFrame(watch);
      else if(observer)observer.disconnect();
    }
    requestAnimationFrame(watch);
  },true);
}());